'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotHistogram2dcontourIcon = function PlotHistogram2dcontourIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32.25 29.47' }, props),
        _react2.default.createElement('path', { d: 'M2.84 21.31S-9-4.93 17.14 1.43c0 0 15.29 1.65 14.37 17.55 0 0-3.62 13.33-21.24 9.2z' }),
        _react2.default.createElement('path', { fill: 'currentColor', d: 'M11 1.43c5.37 0 11.63 1.77 14.22 4.08a15.43 15.43 0 0 1 5.51 10.75 9.29 9.29 0 0 1-2.45 7.21 19 19 0 0 1-12.66 4.7A11.68 11.68 0 0 1 7.14 25C.88 18.71-.14 7.21 3.6 3.47c1.36-1.29 4-2 7.42-2M11 0C7.55 0 4.35.68 2.58 2.45c-4.49 4.35-3 16.81 3.54 23.34a12.91 12.91 0 0 0 9.52 3.67 20.68 20.68 0 0 0 13.68-5.1c4.49-4.49 4.08-14.09-3.06-20.14C23.4 1.7 16.66 0 11 0zm1.9 6.94c4.22 0 7.83 1.16 8.85 2.18a8.15 8.15 0 0 1 2.58 6.12 6.92 6.92 0 0 1-2 5.51 6.79 6.79 0 0 1-5 1.7 9.45 9.45 0 0 1-6.53-2.72c-4-4.08-5.8-9.46-3.87-11.5a11.31 11.31 0 0 1 6-1.29m2.18 3.61a3.15 3.15 0 0 1 1.56.61c2 2 3.07 4.9 2.79 5.37a2.16 2.16 0 0 1-1.9 1.16 6.8 6.8 0 0 1-3.2-1.43c-2.45-2-2.59-3.33-2.45-4.22a.87.87 0 0 1 .09-.34 4.7 4.7 0 0 1 3.06-1.15m-2.18-5c-2.93 0-5.51.55-6.8 1.7-2.89 2.89-.44 9.28 3.92 13.5A10.61 10.61 0 0 0 17.55 24a8.64 8.64 0 0 0 6-2.31 10 10 0 0 0-.75-13.81c-1.57-1.3-5.92-2.32-9.87-2.32zm2.22 3.57c-2 0-4.36 1.15-4.63 2.31-.75 2.18.68 4.08 2.86 5.85A7.72 7.72 0 0 0 17.55 19a3.46 3.46 0 0 0 3.06-1.56c1-1.63-.89-5.24-2.93-7.28a3.24 3.24 0 0 0-2.58-1' })
    );
};

exports.default = PlotHistogram2dcontourIcon;